export default function storePerformanceObjectivesReducer(state = {
  data: {},
  fetching: false,
  fetched: false
}, action) {
  switch (action.type) {
    case 'GET_STORE_PERFORMANCE_OBJECTIVES_DATA_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case 'GET_STORE_PERFORMANCE_OBJECTIVES_DATA_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payLoad,
      };
    }
    case 'GET_STORE_PERFORMANCE_OBJECTIVES_DATA_REJECTED': {
      return {
        ...state,
        errors: action.payLoad.errors
      };
    }
    default:
  }

  return {...state};
}
